import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	productComponents: {
		id: 'project-pages-project-directories.components.view.global-components-toggle-button.product-components',
		defaultMessage: '{product} components',
		description:
			'Button text showing whether Jira components or Compass components are enabled. Product will always be Jira or Compass.',
	},
});
